import React from 'react';
import {
	func,
	object,
	bool
} from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { QuizSentence } from '../../molecules/QuizSentence/index';
import QuizResultModal from '../QuizResultModal/index';
import style from './style';

const Presenter = ({
	quizContentProps,
	quizResultProps,
	showResult,
	className
}) => {
	if (!quizContentProps) return null;

	const {
		quiz,
		answers,
		quizSize,
		isLastQuestion,
		onAnswer,
		onNext,
		onBack,
		onSubmit,
		timeLimit,
		onTimeout,
	} = quizContentProps;
	const NextButton = !isLastQuestion ?
		(
			<style.FloatingActionButton onClick={onNext}> NEXT</style.FloatingActionButton>
		) :
		(
			<style.FloatingActionButton onClick={onSubmit}>FINISH</style.FloatingActionButton>
		);
	return (
		<style.Wrapper className={className}>
			<style.QuizHeader>
				{`No. ${quiz.number} / ${quizSize}`}
			</style.QuizHeader>
			<style.ContentWrapper>
				<style.CountdownTimer
					interval={100}
					remaining={timeLimit}
					notifyComplete={onTimeout}
					stop={showResult}
				/>
				<style.h4>Question</style.h4>
				<style.QuestionWrapper>
					<ReactMarkdown
						source={quiz.question}
						renderers={{
							text: function Renderer(props) {
								return <QuizSentence
									content={props.children}
									options={quiz.options}
									onAnnotation={(answer) => {
										return quiz.answers ?
											1 + quiz.answers.findIndex((a => a === answer)) : 0;
									}}
								/>;
							}
						}}
					/>
				</style.QuestionWrapper>
				<style.h4>Answer</style.h4>
				<style.AnswerForm
					options={quiz.options}
					answers={answers}
					correctAnswers={quiz.answers}
					onAnswer={(correctAnswer, selectedIdx, answer) => {
						onAnswer && onAnswer(correctAnswer, selectedIdx, answer);
					}}
				/>
			</style.ContentWrapper>
			<style.QuizFooter>
				<div>
					<style.FloatingActionButton onClick={onBack}>BACK</style.FloatingActionButton>
				</div>
				<div id='space'>
				</div>
				<div>
					{NextButton}
				</div>
				
			</style.QuizFooter>
			<QuizResultModal
				show={!!quizResultProps}
				{...quizResultProps}
			/>
		</style.Wrapper>
	);
};

Presenter.propTypes = {
	quizContentProps: object.isRequired,
	isLastQuestion: bool,
	quiz: object,
	onAnswer: func,
	onNext: func,
	onBack: func,
	onSubmit: func
};

export default Presenter;